import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Senior Tech Consultant",
          "Solution Architect",
          "Independent Tech Advisor",
          "Full Stack Developer",
          "Cloud & DevOps Expert",
          "AI Implementation Specialist",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
